// Casillas de habeas data del catálogo público (Ley 1581): la autorización de
// tratamiento de datos es obligatoria para enviar un pedido y las promociones
// son una casilla aparte y opcional. Ninguna viene marcada. El backend rechaza
// el pedido sin `autorizacionDatos: true` y guarda la prueba de cada una.
//
// Si cambia este texto, subir VERSION_AUTORIZACION_DATOS en el backend.

import React, { useState } from 'react';
import PoliticaDatosTienda from './PoliticaDatosTienda';

export const AUTORIZACION_FALTANTE_MSG = 'Debes autorizar el tratamiento de tus datos para continuar.';

const AutorizacionDatos = ({ tienda, autoriza, onAutoriza, promociones, onPromociones, idPrefix = 'ad' }) => {
  const [verPolitica, setVerPolitica] = useState(false);

  return (
    <div className="space-y-2">
      <label htmlFor={`${idPrefix}-autoriza`} className="flex items-start gap-2 text-xs text-gray-600 cursor-pointer">
        <input
          id={`${idPrefix}-autoriza`}
          type="checkbox"
          checked={autoriza}
          onChange={(e) => onAutoriza(e.target.checked)}
          className="mt-0.5 h-4 w-4 flex-shrink-0 accent-purple-600"
        />
        <span>
          Autorizo a <strong>{tienda.nombre}</strong> a tratar mis datos para gestionar mi pedido y contactarme sobre él,
          según su{' '}
          <button
            type="button"
            onClick={(e) => { e.preventDefault(); setVerPolitica(true); }}
            className="text-purple-600 font-bold underline"
          >
            política de tratamiento de datos
          </button>
          .
        </span>
      </label>

      <label htmlFor={`${idPrefix}-promociones`} className="flex items-start gap-2 text-xs text-gray-500 cursor-pointer">
        <input
          id={`${idPrefix}-promociones`}
          type="checkbox"
          checked={promociones}
          onChange={(e) => onPromociones(e.target.checked)}
          className="mt-0.5 h-4 w-4 flex-shrink-0 accent-purple-600"
        />
        <span>Quiero recibir promociones de {tienda.nombre} (opcional).</span>
      </label>

      {verPolitica && <PoliticaDatosTienda tienda={tienda} onClose={() => setVerPolitica(false)} />}
    </div>
  );
};

export default AutorizacionDatos;
